import { WebPlugin } from '@capacitor/core';
export class NuanceSpeechkitWeb extends WebPlugin {
    initSpeechKit(options) {
        console.log(options);
        throw new Error('Method not implemented.');
    }
    start(options) {
        console.log(options);
        throw new Error('Method not implemented.');
    }
    async echo(options) {
        console.log('ECHO', options);
        return options;
    }
}
//# sourceMappingURL=web.js.map